import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { Translation, Translator } from '@morningtrain/react-translations'

export default function PermissionGroupCategoryTitle () {
  const category = useValue('key')

  return (
    <Translator namespace='permissions.categories'>
      <Translation name={category} />
    </Translator>
  )
}
